import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, CircularProgress, Typography } from '@mui/material';
var AuthCallback = function () {
    var navigate = useNavigate();
    useEffect(function () {
        var handleCallback = function () {
            var url = new URL(window.location.href);
            var code = url.searchParams.get('code');
            var state = url.searchParams.get('state');
            //@ts-ignore
            axios.get("".concat(process.env.REACT_APP_API_URL, "?action=zoom_auth0_auth_exchange_tokens&code=").concat(code, "&state=").concat(state))
                .then(function (res) {
                var data = res.data;
                window.location.href = '/auth-success';
            })
                .catch(function (e) { return console.log(e); });
        };
        handleCallback();
    }, [navigate]);
    return (_jsxs(Box, { sx: { height: '100vh', width: '100%', pt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }, children: [_jsx(Box, { sx: { height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }, children: _jsx(CircularProgress, { size: 80 }) }), _jsx(Typography, { sx: { my: 1 }, variant: 'h6', children: "Authentication in progress.. Please wait.." })] }));
};
export default AuthCallback;
